import { styled, Theme } from '@material-ui/core';
import BookCoverImageLink from './BookCoverImageLink';
import { BlankLink } from '../../../shared/components';

export const StyledHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '1rem',

  '& .controls': {
    display: 'flex',
    alignItems: 'center',
    gap: '0.2rem',
    flex: 0,
  },
});

export const Wrapper = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2, 1),
  borderBottom: `1px solid ${theme.config.appbarColors.borderColor}`,
  '&:first-of-type': {
    paddingTop: 0,
  },
  '&:last-of-type': {
    borderBottom: 'none',
    paddingBottom: 0,
  },
}));

export const Title = styled('h3')<Theme>(({ theme }) => ({
  margin: 0,
  '& span': {
    color: theme.palette.primary.main,
    fontStyle: 'italic',
    marginLeft: '0.5rem',
  },
}));

export const BookTrajectoriesWrapper = styled('div')({
  margin: '0.5rem 0',
  display: 'flex',
});

export const BookCover = styled('div')({
  width: '8rem',
  height: '12rem',
  marginRight: '1rem',
  '&:hover StyledBookCoverImageLink img': {
    transform: 'scale(1.05)',
    opacity: 0.5,
  },
});

export const Trajectories = styled('div')({
  width: 'calc(100% - 9rem)',
  minHeight: '12rem',
});

export const ShowAllToggleWrapper = styled('footer')<Theme>(({ theme }) => ({
  paddingLeft: '9rem',

  '& .toggle': {
    fontStyle: 'italic',
    fontSize: '1.4rem',
    color: theme.palette.grey['500'],
    padding: '0 1rem',
  },
}));

export const StyledBookCoverImageLink = styled(BookCoverImageLink)({
  borderRadius: '1rem',
  '& img': {
    transition: '.3s',
    transform: 'scale(1)',
    opacity: 1,
    zIndex: 3,
  },
});

export const TrajectoriesListWrapper = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  borderRadius: theme.config.defaultBorderRadius,
  fontSize: theme.typography.h4.fontSize,
}));

export const TrajectoriesContentWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
}));

export const TrajectoriesListHeader = styled('header')<Theme>(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontStyle: 'italic',
  alignItems: 'center',
  color: theme.palette.grey['500'],
}));

export const StyledLink = styled(BlankLink)({
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'inline-block',
});

export const StyledTrajectoryTitle = styled('span')({
  maxWidth: '100%',
  textWrap: 'balance',
});

export const StyledBookmarkWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
});

export const StyledTypography = styled('span')({
  fontWeight: 700,
  fontSize: '14px',
  whiteSpace: 'nowrap',
});
